import { Field, FieldProps } from 'formik'
import React, { useState } from 'react'
import styled, { css } from 'styled-components'

import CheckboxMark from '../icons/CheckboxMark'
import { devices, media } from '../../utils/style-utils'

interface ICheckbox {
	label: string
	field: any
	checked: boolean
	onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void
}

const Checkbox = ({ label, field, checked, onChange }: ICheckbox) => {
	return (
		<Label
			isClicked={false}
			htmlFor={label}
		>
			<InputWrapper error={field.touched && !!field.error}>
				<CheckboxInput
					id={label}
					type='checkbox'
					onChange={onChange}
				/>
				<CheckMarkDiv isClicked={checked}>{checked && <CheckboxMark />}</CheckMarkDiv>
			</InputWrapper>
			{label}
		</Label>
	)
}

const CheckMarkDiv = styled.span<{ isClicked: boolean }>`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 24px;
	height: 24px;
	border-radius: 4px;
	cursor: pointer;

	background-color: ${(props) => (props.isClicked ? 'var(--baby-blue)' : 'var(--off-white)')};
`

const CheckboxInput = styled.input`
	display: none;
	width: 24px;
	height: 24px;
`
const Label = styled.label<{ isClicked: boolean }>`
	${(props) => props.isClicked && 'background-color: white'};

	display: flex;
	flex-direction: row;
	align-items: center;
	padding: 8px;
	gap: 8px;
	border-radius: 8px;
	width: fit-content;
`

const InputWrapper = styled.div<{ error?: boolean }>`
	display: flex;
	/* align-items: center; */
	gap: var(--spacer-sm);
	/* border-radius: 56px; */
	/* background: #ffffff; */
	/* outline: 0px; */
	/* border: 0px; */

	/* width: 100%; */
	/* height: 56px; */

	font-family: var(--font-akzidenz);
	font-weight: 300;
	font-size: 1.25rem;
	line-height: 2rem;

	color: var(--black);
	::placeholder {
		color: var(--input-text-color);
	}

	&:hover {
		outline: 2px solid var(--blue-300);
	}

	&:focus-within {
		outline: 2px solid var(--blue-500);
	}

	${(p) =>
		p.error &&
		css`
			outline: 2px solid var(--danger-red-500);
			background: var(--danger-red-100);

			${devices.safariDesktop`
				border: 2px solid var(--danger-red-500);
				background: var(--danger-red-100);
			`}
		`}

	transition: outline 0.1s;

	${media.desktopHuge`
		height: 72px;
	`}
`

export default Checkbox
